// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9363 ? "cff4c5fa" : chunkId) + "." + {"1222":"4502fbb8bd502031","5726":"e1e377c249f29733","6269":"4aad338438d27134","9363":"7d412714058154c2"}[chunkId] + ".js";
};